class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.minOrderAmount = this.notification.getAttribute('data-min-order');
    this.relatedUpsellsSectionId =
      this.notification.getAttribute('data-related-upsells-section') || 'cart-notification-related-products';
    this.notificationDisplayedQuantity = 1;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll(
      '.cart-notification__close, .cart-notification__links button[type="button"]'
    ).forEach((closeButton) => closeButton.addEventListener('click', this.close.bind(this)));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      (evt) => {
        if (evt.target !== this.notification || evt.propertyName !== 'transform') return;
        this.notification.focus();
        trapFocus(this.notification);
        document.dispatchEvent(new CustomEvent('cart-notification:opened'));
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  updateFreeShippingBar(cartData, targetVal) {
    var cartTotal = (cartData.total_price / 100).toFixed(2);
    var cartItems = cartData.items;
    var minOrderAmount = parseInt(targetVal).toFixed(2);
    var progressBarContainer = document.querySelector('.free-shipping__wrapper');
    var progressBar = document.querySelector('.free-shippingThreshold__progress');
    var progressNum = document.querySelector('.free-shipping__num');
    var itemsWithFreeShipping = cartItems.filter(item => item.properties.freeShipping);

    if (!progressBarContainer || !progressBar || !progressNum) return;

    if (itemsWithFreeShipping.length == cartItems.length) {
      progressBarContainer.classList.add('hidden');
    } else {
      progressBarContainer.classList.remove('hidden');
    }

    if (itemsWithFreeShipping.length) {
      let sum = 0;
      itemsWithFreeShipping.forEach(item => {
        sum += item.final_line_price;
      });
      sum = (sum / 100).toFixed(2);
      cartTotal = cartTotal - sum;
    }

    var result = Math.round(100 * cartTotal / minOrderAmount);
    var amountRemaining = (minOrderAmount - cartTotal).toFixed(2);
    progressBar.setAttribute('style', `width: ${result}%`);

    const successMsg = document.querySelector('.free-shipping__success-msg');
    const remainingMsg = document.querySelector('.free-shipping__remaining-msg');

    if (amountRemaining <= 0) {
      if (successMsg) successMsg.style.display = 'block';
      if (remainingMsg) remainingMsg.style.display = 'none';
    } else {
      if (successMsg) successMsg.style.display = 'none';
      if (remainingMsg) remainingMsg.style.display = 'block';
    }
    progressNum.textContent = amountRemaining;
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.resetCartTotalItemsCount();
    this.resolveNotificationDisplayedQuantity(parsedState);

    const sections = this.getSectionsToRender();
    const missingSections = [];

    sections.forEach((section) => {
      const updated = CartNotificationHelpers.updateSectionElement(
        section,
        parsedState.sections?.[section.id],
        { parsedState, itemKey: this.cartItemKey }
      );

      if (!updated) {
        missingSections.push(section.id);
      }
    });

    if (missingSections.length) {
      const responseSections = await CartNotificationHelpers.fetchSections(missingSections);
      sections.forEach((section) => {
        if (!missingSections.includes(section.id)) return;
        CartNotificationHelpers.updateSectionElement(section, responseSections[section.id], {
          parsedState,
          itemKey: this.cartItemKey,
        });
      });
    }

    this.syncNotificationDisplayedQuantityFromDom();
    this.hideUpsells();

    const cartData = await this.fetchCartData();
    if (cartData) {
      this.updateCartTotalItemsLink(cartData.item_count);
      this.updateFreeShippingBar(cartData, this.minOrderAmount);
      this.updateSubtotalFromCart(cartData);
    }

    if (this.header) this.header.reveal();
    this.open();

    const productId = this.resolveAddedProductId(parsedState);
    if (productId) {
      await this.refreshRelatedUpsells(productId);
    } else {
      this.showUpsells();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-notification-subtotal'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return CartNotificationHelpers.getSectionInnerHTML(html, selector);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  resolveAddedProductId(parsedState) {
    if (parsedState?.product_id) return parsedState.product_id;

    if (parsedState?.key && parsedState?.items?.length) {
      const item = parsedState.items.find((cartItem) => cartItem.key === parsedState.key);
      if (item?.product_id) return item.product_id;
    }

    if (parsedState?.items?.length) {
      const lastItem = parsedState.items[parsedState.items.length - 1];
      if (lastItem?.product_id) return lastItem.product_id;
    }

    return null;
  }

  resolveNotificationDisplayedQuantity(parsedState) {
    if (parsedState.quantity) {
      this.notificationDisplayedQuantity = parsedState.quantity;
      return;
    }

    if (parsedState.key && parsedState.items?.length) {
      const item = parsedState.items.find((cartItem) => cartItem.key === parsedState.key);
      if (item?.quantity) {
        this.notificationDisplayedQuantity = item.quantity;
        return;
      }
    }

    this.notificationDisplayedQuantity = 1;
  }

  syncNotificationDisplayedQuantityFromDom() {
    const input = document.querySelector('#cart-notification-product .quantity__input');
    if (!input) return;

    const quantity = parseInt(input.value, 10);
    if (Number.isFinite(quantity) && quantity > 0) {
      this.notificationDisplayedQuantity = quantity;
    }
  }

  getNotificationDisplayedQuantity() {
    return this.notificationDisplayedQuantity || 1;
  }

  resetCartTotalItemsCount() {
    const totalEl = document.getElementById('cart-notification-total');
    const countEl = totalEl?.querySelector('[data-cart-notification-more-count]');
    if (countEl) {
      countEl.textContent = '';
      countEl.classList.add('visually-hidden');
    }
    if (totalEl) totalEl.classList.add('hidden');
  }

  updateCartTotalItemsLink(cartItemCount) {
    const totalEl = document.getElementById('cart-notification-total');
    const countEl = totalEl?.querySelector('[data-cart-notification-more-count]');
    if (!totalEl || !countEl) return;

    const moreItemsCount = cartItemCount - this.getNotificationDisplayedQuantity();

    if (moreItemsCount <= 0) {
      totalEl.classList.add('hidden');
      countEl.textContent = '';
      countEl.classList.add('visually-hidden');
      return;
    }

    countEl.textContent = String(moreItemsCount);
    countEl.classList.remove('visually-hidden');
    totalEl.classList.remove('hidden');
  }

  fetchCartData() {
    return fetch('/cart.js')
      .then((response) => response.json())
      .catch(() => null);
  }

  updateSubtotalFromCart(cartData) {
    const subtotalEl = document.getElementById('cart-notification-subtotal');
    if (!subtotalEl || !cartData?.total_price) return;

    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      subtotalEl.textContent = Shopify.formatMoney(cartData.total_price, window.theme?.moneyFormat);
    }
  }

  hideUpsells() {
    const upsells = document.getElementById('cart-notification-upsells');
    if (upsells) upsells.classList.add('hidden');
  }

  showUpsells() {
    const upsells = document.getElementById('cart-notification-upsells');
    if (!upsells) return;

    const hasSlides = upsells.querySelector('.cart-notification__upsells-slide');
    if (!hasSlides) return;

    upsells.classList.remove('hidden');
    document.dispatchEvent(new CustomEvent('cart-notification:opened'));
  }

  getProductRecommendationsUrl(productId) {
    const baseUrl =
      this.notification.getAttribute('data-product-recommendations-url') ||
      window.routes?.product_recommendations_url ||
      '/recommendations/products';

    const params = new URLSearchParams({
      section_id: this.relatedUpsellsSectionId,
      product_id: String(productId),
      limit: '12',
    });

    return `${baseUrl}?${params.toString()}`;
  }

  parseRecommendationsUpsells(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    return (
      doc.getElementById('cart-notification-upsells') ||
      doc.querySelector(`#shopify-section-${this.relatedUpsellsSectionId} #cart-notification-upsells`)
    );
  }

  restoreUpsellFallback(upsells, fallbackHtml, fallbackDataset) {
    upsells.innerHTML = fallbackHtml;
    Object.entries(fallbackDataset).forEach(([key, value]) => {
      upsells.dataset[key] = value;
    });
    this.showUpsells();
  }

  async refreshRelatedUpsells(productId) {
    const upsells = document.getElementById('cart-notification-upsells');
    if (!upsells) return;

    const fallbackHtml = upsells.innerHTML;
    const fallbackDataset = { ...upsells.dataset };
    const url = this.getProductRecommendationsUrl(productId);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Recommendations request failed (${response.status})`);

      const html = await response.text();
      const newUpsells = this.parseRecommendationsUpsells(html);

      if (newUpsells?.querySelector('.cart-notification__upsells-slide')) {
        newUpsells.classList.add('hidden');
        upsells.replaceWith(newUpsells);
        this.showUpsells();
        return;
      }

      this.restoreUpsellFallback(upsells, fallbackHtml, fallbackDataset);
    } catch (error) {
      console.error('[CartNotification] refreshRelatedUpsells failed:', error);
      this.restoreUpsellFallback(upsells, fallbackHtml, fallbackDataset);
    }
  }
}

customElements.define('cart-notification', CartNotification);

const CartNotificationHelpers = {
  get sectionsUrl() {
    return window.routes?.cart_url || '/cart';
  },

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    if (element) {
      return element.childElementCount === 0 ? element.textContent.trim() : element.innerHTML;
    }

    return '';
  },

  getCartNotificationProductHtml(html, { itemKey, parsedState } = {}) {
    if (!html) return '';

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const variantId =
      parsedState?.variant_id ||
      parsedState?.id ||
      parsedState?.items?.find((item) => item.key === itemKey)?.variant_id;

    const getItemHtml = (itemEl) => {
      if (!itemEl) return { html: '', itemKey: null };
      return {
        html: itemEl.innerHTML,
        itemKey: itemEl.id.replace('cart-notification-product-', ''),
      };
    };

    if (itemKey) {
      const byKey = doc.getElementById(`cart-notification-product-${itemKey}`);
      if (byKey) return getItemHtml(byKey);

      const keyPrefix = String(itemKey).split(':')[0];
      if (keyPrefix) {
        const byPrefix = doc.querySelector(`[id^="cart-notification-product-${keyPrefix}"]`);
        if (byPrefix) return getItemHtml(byPrefix);
      }
    }

    if (variantId) {
      const input = doc.querySelector(`input[data-quantity-variant-id="${variantId}"]`);
      const itemEl = input?.closest('.cart-item[id^="cart-notification-product-"]');
      if (itemEl) return getItemHtml(itemEl);
    }

    const items = doc.querySelectorAll('.cart-item[id^="cart-notification-product-"]');
    if (items.length === 1) return getItemHtml(items[0]);
    if (items.length > 1) return getItemHtml(items[items.length - 1]);

    return { html: '', itemKey: null };
  },

  fetchSections(sectionIds) {
    const sections = Array.isArray(sectionIds) ? sectionIds.join(',') : sectionIds;

    return fetch(`${this.sectionsUrl}?sections=${sections}`).then((response) => response.json());
  },

  updateSectionElement(section, sectionContent, context = {}) {
    const targetElement = document.getElementById(section.id);
    if (!targetElement || sectionContent == null) return false;

    if (section.id === 'cart-notification-product') {
      const { html: sectionHtml, itemKey: resolvedItemKey } = this.getCartNotificationProductHtml(
        sectionContent,
        { itemKey: context.itemKey, parsedState: context.parsedState }
      );
      const cartNotification = document.querySelector('cart-notification');

      if (!sectionHtml) {
        targetElement.innerHTML = '';
        if (cartNotification) cartNotification.cartItemKey = null;
        return false;
      }

      targetElement.innerHTML = sectionHtml;
      if (cartNotification && resolvedItemKey) cartNotification.cartItemKey = resolvedItemKey;
      return true;
    }

    const sectionHtml = this.getSectionInnerHTML(sectionContent, section.selector);

    if (section.id === 'cart-notification-subtotal' || section.id === 'cart-notification-button') {
      if (sectionHtml) targetElement.textContent = sectionHtml.trim();
      return Boolean(sectionHtml);
    }

    if (sectionHtml) {
      targetElement.innerHTML = sectionHtml;
      return true;
    }

    return false;
  },

  syncQuantityInput(parsedState, itemKey) {
    if (!itemKey || !parsedState.items?.length) return;

    const item = parsedState.items.find((cartItem) => cartItem.key === itemKey);
    const input = document.querySelector('#cart-notification-product .quantity__input');
    if (!item || !input) return;

    const line = parsedState.items.indexOf(item) + 1;
    input.value = item.quantity;
    input.dataset.index = line;
    input.id = `Notification-quantity-${line}`;

    const quantityInput = input.closest('quantity-input');
    if (quantityInput?.validateQtyRules) {
      quantityInput.validateQtyRules();
    }
  }
};

class CartNotificationItems extends CartItems {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('cart-notification-line-item-status');
  }

  get cartUpdateSource() {
    return 'cart-notification-items';
  }

  getActiveItemKey() {
    return document.querySelector('cart-notification')?.cartItemKey;
  }

  get cartNotification() {
    return document.querySelector('cart-notification');
  }

  getSectionContent(parsedState, section) {
    return parsedState.sections?.[section.section] || parsedState.sections?.[section.id];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return CartNotificationHelpers.getSectionInnerHTML(html, selector);
  }

  renderNotificationSections(parsedState) {
    const sections = this.getSectionsToRender();
    const missingSections = [];

    sections.forEach((section) => {
      const sectionContent = this.getSectionContent(parsedState, section);
      const updated = CartNotificationHelpers.updateSectionElement(section, sectionContent, {
        parsedState,
        itemKey: this.getActiveItemKey(),
      });

      if (!updated) {
        missingSections.push(section.section);
      }
    });

    if (missingSections.length) {
      CartNotificationHelpers.fetchSections(missingSections).then((responseSections) => {
        sections.forEach((section) => {
          if (!missingSections.includes(section.section)) return;
          CartNotificationHelpers.updateSectionElement(section, responseSections[section.section], {
            parsedState,
            itemKey: this.getActiveItemKey(),
          });
        });
      });
    }

    CartNotificationHelpers.syncQuantityInput(parsedState, this.getActiveItemKey());

    const cartNotification = this.cartNotification;
    if (cartNotification) {
      cartNotification.syncNotificationDisplayedQuantityFromDom();
      cartNotification.fetchCartData().then((cartData) => {
        if (!cartData) return;
        cartNotification.updateCartTotalItemsLink(cartData.item_count);
        cartNotification.updateFreeShippingBar(cartData, cartNotification.minOrderAmount);
      });
    }
  }

  onCartUpdate() {
    const sections = this.getSectionsToRender().map((section) => section.section).join(',');

    CartNotificationHelpers.fetchSections(sections)
      .then((responseSections) => {
        this.renderNotificationSections({ sections: responseSections });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    const itemKey = this.getActiveItemKey();
    const sections = [
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
        selector: '.shopify-section'
      },
      {
        id: 'cart-notification-subtotal',
        section: 'cart-notification-subtotal',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];

    if (itemKey) {
      sections.unshift({
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[id="cart-notification-product-${itemKey}"]`
      });
    }

    return sections;
  }

  updateSubtotalFromSection() {
    return CartNotificationHelpers.fetchSections('cart-notification-subtotal').then((responseSections) => {
      CartNotificationHelpers.updateSectionElement(
        {
          id: 'cart-notification-subtotal',
          section: 'cart-notification-subtotal',
          selector: '.shopify-section'
        },
        responseSections['cart-notification-subtotal']
      );
    });
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: CartNotificationHelpers.sectionsUrl
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Notification-quantity-${line}`);

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.renderNotificationSections(parsedState);

        if (!this.getSectionContent(parsedState, { section: 'cart-notification-subtotal', id: 'cart-notification-subtotal' })) {
          this.updateSubtotalFromSection();
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (quantityElement && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        const cartNotification = this.cartNotification;
        if (cartNotification) {
          cartNotification.updateFreeShippingBar(parsedState, cartNotification.minOrderAmount);
        }
        this.updateLiveRegions(line, message);

        if (quantityElement && name && quantityElement.closest('quantity-input')?.querySelector(`[name="${name}"]`)) {
          quantityElement.closest('quantity-input').querySelector(`[name="${name}"]`).focus();
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: this.cartUpdateSource });
      })
      .catch(() => {
        if (this.lineItemStatusElement) {
          this.lineItemStatusElement.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    if (!this.lineItemStatusElement || !message) return;

    this.lineItemStatusElement.textContent = message;
    this.lineItemStatusElement.setAttribute('aria-hidden', false);

    setTimeout(() => {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    document.getElementById('cart-notification-items')?.classList.add('cart__items--disabled');
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    document.getElementById('cart-notification-items')?.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-notification-items', CartNotificationItems);
